import React from 'react'
import './Shimmer.css'

export const Shimmer = () => {
  return (
    <>
      <div className="shimmer-item shimmer"></div>
      <div className="shimmer-item shimmer"></div>
      <div className="shimmer-item shimmer"></div>
      <div className="shimmer-item shimmer"></div>
      <div className="shimmer-item shimmer"></div>
      <div className="shimmer-item shimmer"></div>
      <div className="shimmer-item shimmer"></div>
      <div className="shimmer-item shimmer"></div>
      <div className="shimmer-item shimmer"></div>
      <div className="shimmer-item shimmer"></div>
    </>
  )
}

export const TableShimmer = ({ columns }) => {
  const shimmerRows = Array.from({ length: 10 })
  return (
    <>
      {shimmerRows.map((_, index) => (
        <tr key={index}>
          <td colSpan={columns} className="shimmer">
            {/* Shimmer will span across all columns */}
          </td>
        </tr>
      ))}
    </>
  )
}
